class HomeService {
  constructor() {
    this.apiUrl = process.env.REACT_APP_API_URL;
    this.token = localStorage.getItem('token');
  }

  async analytics(startDate, endDate) {
    return fetch(
        `${this.apiUrl}/video-analytics/home/progress-analytics/?startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': this.token,
          },
        })
        .then((response) => {
          return response.json();
        });
  }

  async analyticsChart(startDate, endDate) {
    return fetch(
        `${this.apiUrl}/video-analytics/home/progress-analytics/chart/?startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': this.token,
          },
        })
        .then((response) => {
          return response.json();
        });
  }

  async reactions(startDate, endDate) {
    return fetch(
        `${this.apiUrl}/video-analytics/home/reaction-analytics/?startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': this.token,
          },
        })
        .then((response) => {
          return response.json();
        });
  }

  async reactionsChart(startDate, endDate) {
    return fetch(
        `${this.apiUrl}/video-analytics/home/reaction-analytics/chart/?startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': this.token,
          },
        })
        .then((response) => {
          return response.json();
        });
  }
}

export default HomeService;
